<script setup lang="ts">
import SectionCard from './SectionCard.vue';
import DetailMoreLink from '@/components/DetailMoreLink.vue';
import type { SectionComponentProps } from './section-props';

const props = defineProps<SectionComponentProps>();
</script>

<template>
  <SectionCard
    :id="props.id"
    type="intro"
    :title="props.section.title"
    :summary="props.section.summary"
    :show-draft-badge="props.showDraftBadge"
  >
    <template #more>
      <DetailMoreLink
        :section="props.section"
        target-anchor="module:achievement-intro"
        :preview-token="props.previewToken"
      />
    </template>
  </SectionCard>
</template>
